import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];
  static values = { expanded: Boolean };

  toggle() {
    this.expandedValue = !this.expandedValue;
  }

  expandedValueChanged() {
    if (this.expandedValue) {
      this.contentTarget.classList.remove("line-clamp-5");
    } else {
      this.contentTarget.classList.add("line-clamp-5");
    }
  }
}
